module.exports = __webpack_public_path__ + "bbaeaf181768a6b55c9e2ccb294cf519.png";